<template>
  <div class="PlatformReports">
    <ShPageHeader title="Lista raportów"
                  :description="`Lista raportów z wszystkich projektów IVR`"
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'lista raportów', path: '/reports' }
                  ]"
    />
    <ShPageLayout>
      <ReportsList />
    </ShPageLayout>
  </div>
</template>

<script>
import ReportsList from '@/components/Reports/ReportsList';

export default {
  name: 'PlatformReports',
  components: {
    ReportsList,
  },
};
</script>
